"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var isTiendeo_1 = require("../../utils/isTiendeo");
var CookieStrategy_1 = require("../CookieStrategy");
var BrowserCookies = /** @class */ (function (_super) {
    __extends(BrowserCookies, _super);
    function BrowserCookies(cookieDomain) {
        return _super.call(this, cookieDomain, window.location.hostname) || this;
    }
    BrowserCookies.prototype.Get = function (cookieName) {
        var cookieNameEQ = cookieName + "=";
        var allCookies = document.cookie.split(";");
        for (var _i = 0, allCookies_1 = allCookies; _i < allCookies_1.length; _i++) {
            var cookie = allCookies_1[_i];
            while (cookie.charAt(0) === " ") {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(cookieNameEQ) === 0) {
                return cookie.substring(cookieNameEQ.length, cookie.length);
            }
        }
        return null;
    };
    BrowserCookies.prototype.Set = function (name, value, expiryHours) {
        document.cookie = this._getCookieName(name, value, expiryHours);
    };
    BrowserCookies.prototype._getCookieName = function (cookieName, value, hours) {
        var domain = this._getCookieDomain();
        var expires = "";
        if (hours) {
            var expiresIn = (hours === -Infinity)
                ? this.BEGINNING_OF_TIME
                : this._getExpireDate(hours).toUTCString();
            expires = "; expires=" + expiresIn;
        }
        var cookie = cookieName + "=" + value + expires + domain + "; path=/";
        if (!domain || domain.includes('tiendeo')) {
            var sameSite = this.SAMESITES[cookieName.toLowerCase()] || 'Lax';
            cookie += "; SameSite=" + sameSite;
            if (sameSite === 'None') {
                cookie += '; Secure';
            }
        }
        return cookie;
    };
    BrowserCookies.prototype._getCookieDomain = function () {
        var domain = "";
        if (this.COOKIE_DOMAIN != null && isTiendeo_1.default(this.currentDomain)) {
            domain = "; domain=" + this.COOKIE_DOMAIN;
        }
        return domain;
    };
    return BrowserCookies;
}(CookieStrategy_1.default));
exports.default = BrowserCookies;
//# sourceMappingURL=BrowserCookies.js.map